import React from "react";
import { useNavigate } from "react-router-dom";
import { createBlogCategory } from "adminApi/BlogApi/BlogCategory";
import { BlogCategoryRules } from "validation/ValidationRules";
import { validateForm } from "utils/validation";
import Spinner from "Common/Globle/Spinner";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import fields from "../../json/BlogCategoryFields.json";
import BlogCategoryForm from "./Components/BlogCategoryForm";

const AddBlogCategory = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setErrors } = useFormChange(initialValues, BlogCategoryRules);

    const { loading, handleSubmit } = useFormSubmit(
        async (formValues) => await createBlogCategory({ data: formValues }),
        (vals) => {
            const err = validateForm(vals, BlogCategoryRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Category created successfully"
    );

    return (
        <>
            {loading && <Spinner isSpinner={true} />}
            <BlogCategoryForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loading}
                title="Add Blog Category"
                submitLabel="Create Category"
            />
        </>
    );
};

export default AddBlogCategory;
